import { render, staticRenderFns } from "./EditCompanyEmployeeModalForm.vue?vue&type=template&id=4fb6d212&scoped=true&"
import script from "./EditCompanyEmployeeModalForm.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyEmployeeModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditCompanyEmployeeModalForm.vue?vue&type=style&index=0&id=4fb6d212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6d212",
  null
  
)

export default component.exports